var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4999 7.5C21.9999 15 16.4999 21 9.49995 21C7.08804 21 4.67613 20.6768 2.78389 19.7706C2.35051 19.5631 2.51991 18.985 2.99936 18.9532C5.32944 18.7987 7.25765 18.2423 8.49995 17C3.08355 15.1945 2.14925 8.4995 3.12224 5.00719C3.23648 4.59713 3.76961 4.59499 3.9845 4.96246C5.64598 7.80371 8.80515 9.39003 12.7645 9.02396C12.5932 8.54804 12.4999 8.03492 12.4999 7.5C12.4999 5.01472 14.5146 3 16.9999 3C18.5181 3 19.8607 3.75182 20.6757 4.90346L22.3928 4.65815C22.8207 4.59703 23.1193 5.07087 22.8796 5.43047L21.4999 7.5Z",
    fill: "#777E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterFilled);
export default __webpack_public_path__ + "static/media/twitter-filled.e103294247e1e36b5936c737b6f701c7.svg";
export { ForwardRef as ReactComponent };